import { lazy } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";

import Login from "../pages/login";
import Otp from "../pages/login/otp";
import PublicRoute from "./PublicRoute";
import DynamicGate from "./dynamicGate";
import PrivateRoute from "./PrivateRoute";
import { Paths } from "../common/constants";
import Support from "../pages/login/support";
import PageViewTracker from "./PageViewTracker";
import PrivateWrapper from "../components/containers";
import { privateRoutesList } from "./routes.constants";
import LazyLoader from "../components/routesContainer";
import LoginWrapper from "../components/layout/login-wrapper";

const SubscriptionList = LazyLoader(
  lazy(() => import("../pages/subscription/subscription-list")),
);

const SelectedSubscription = LazyLoader(
  lazy(() => import("../pages/subscription/selected-subscription")),
);

const PageNotFound = LazyLoader(lazy(() => import("../pages/not-found")));

const RoutesManager = () => {
  return (
    <BrowserRouter>
      <DynamicGate>
        <PageViewTracker />
        <Routes>
          <Route
            path={Paths.LOGIN}
            element={
              <LoginWrapper
                childComp={
                  <PublicRoute>
                    <Login />
                  </PublicRoute>
                }
              />
            }
          />
          <Route
            path={Paths.OTP}
            element={
              <LoginWrapper
                childComp={
                  <PublicRoute>
                    <Otp />
                  </PublicRoute>
                }
              />
            }
          />

          <Route
            path={Paths.SUPPORT}
            element={
              <LoginWrapper
                childComp={
                  <PublicRoute>
                    <Support />
                  </PublicRoute>
                }
              />
            }
          />

          <Route
            path={Paths.SUBSCRIPTION}
            element={
              <PrivateRoute>
                <SubscriptionList />
              </PrivateRoute>
            }
          />

          <Route
            path={`${Paths.SELECTED_SUBSCRIPTION}/:planId`}
            element={
              <PrivateRoute>
                <SelectedSubscription />
              </PrivateRoute>
            }
          />

          {privateRoutesList.map(
            (routes: (typeof privateRoutesList)[0], index: number) => (
              <Route
                key={index}
                path={routes.path}
                element={
                  <PrivateWrapper
                    children={<PrivateRoute children={routes.component} />}
                    moduleKey={routes.modulekey}
                    path={routes.pathName}
                  />
                }
              />
            ),
          )}
          <Route path="*" element={<PageNotFound />} />
        </Routes>
      </DynamicGate>
    </BrowserRouter>
  );
};

export default RoutesManager;
